module.exports = __webpack_public_path__ + "img/msc.784159a1.png";